import { validatePeriodSearch } from '../report-period'
import type { ReportPeriodSearch } from '../report-period'

/** Bộ lọc báo cáo tồn Kho phân loại / lấy hương: kỳ chung + tìm loại chè. */
export interface LotStockSearch extends ReportPeriodSearch {
    q?: string
}

export function validateLotStockSearch(
    raw: Record<string, unknown>,
): LotStockSearch {
    return {
        ...validatePeriodSearch(raw),
        q: typeof raw.q === 'string' && raw.q.trim() ? raw.q : undefined,
    }
}

/**
 * Nhóm biểu đồ theo độ dài kỳ: ≤ 31 ngày theo ngày, ≤ 120 ngày theo tuần, dài
 * hơn theo tháng — cột không quá dày để còn đọc được.
 */
export function chartGroupBy(
    from: string,
    to: string,
): 'day' | 'week' | 'month' {
    const days = (Date.parse(to) - Date.parse(from)) / 86_400_000 + 1
    if (days <= 31) return 'day'
    if (days <= 120) return 'week'
    return 'month'
}
